import { render } from "./PageExportLayoutEdit.vue?vue&type=template&id=54d4f452&scoped=true"
import script from "./PageExportLayoutEdit.vue?vue&type=script&lang=js"
export * from "./PageExportLayoutEdit.vue?vue&type=script&lang=js"

import "./PageExportLayoutEdit.vue?vue&type=style&index=0&id=54d4f452&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d4f452"]])

export default __exports__